
import Vue from 'vue';
import { Button } from '@descomplica/vue-components';

export default Vue.extend({
  components: {
    Button,
  },
  methods: {
    useSameTheme() {
      this.$emit('retry', { useSameTheme: true });
    },
    chooseNewTheme() {
      this.$emit('retry', { useSameTheme: false });
    },
  },
});
